import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import BGSVG from '../../svg/website/BgSvg';
import BgSvg2 from '../../svg/website/BgSvg2';
import Dotdotdot from '../../svg/website/Dotdotdot';
import Advantage1Svg from '../../svg/website/Advantage1';
import Advantage2Svg from '../../svg/website/Advantage2';
import Advantage3Svg from '../../svg/website/Advantage3';
import Advantage4Svg from '../../svg/website/Advantage4';
import Advantage5Svg from '../../svg/website/Advantage5';
import Tag1 from '../../svg/website/Tag1';
import Tag2 from '../../svg/website/Tag2';
import Tag3 from '../../svg/website/Tag3';
import Tag4 from '../../svg/website/Tag4';
import Tag5 from '../../svg/website/Tag5';
import Footer from "./components/Footer";
import '../../App.css'
export default function Home() {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [windowSize, setWindowSize] = useState(getWindowSize());
    function getWindowSize() { const { innerWidth, innerHeight } = window; return { innerWidth, innerHeight }; }
    useEffect(() => {
        function handleWindowResize() { setWindowSize(getWindowSize()); }
        window.addEventListener('resize', handleWindowResize);
        return () => { window.removeEventListener('resize', handleWindowResize); };
    }, [])


    const scrollToTop=()=>{
        document.getElementById('navbar').scrollIntoView({ })
    }
    useEffect(()=>{
        scrollToTop()
    },[location])

    return (
        <div className="relative w-full flex flex-col items-center justify-start bg-main" style={{  }}>
            <div className="w-[50%] absolute left-[0] top-[400px] d-flex-m-hidden">
                <BGSVG width='100%' />
            </div>



            {/*tag 1*/}
            <div className="w-full max-w-[1400px] flex flex-row-m-reverse items-stretch justify-start gap-[64px] p-[5%] flex-wrap mt-[64px]">
                <div className="flex-1 flex flex-col items-start justify-start gap-[16px] min-w-[200px]">
                    <div className="flex flex-row font-[700] t-50-39 text-[#425596]">
                        參與計劃的好處
                        <Dotdotdot style={{ marginTop: 5 }} />
                    </div>
                    <div className="mt-[64px]">
                        <Tag1 />
                    </div>
                    <div className="text-[#425596] font-[700] text-[24px] mt-[-10px]">
                        培養學生閱讀的高階思維能力
                    </div>
                    <div className="text-[black] font-[500] text-[20px] mt-[24px]">
                        包括瀏覽、整合，評估等能力，<br/><br/>
                        以及提高線上閱讀的興趣與信心。
                    </div>
                </div>
                <div className="flex-1 flex flex-col items-start-center justify-center gap-[16px] min-w-[200px]">
                    <Advantage1Svg width='100%' style={{ maxWidth: 510 }} />
                </div>
            </div>


            {/*tag 2*/}
            <div className="w-full max-w-[1400px] flex flex-row-m-reverse items-stretch justify-start gap-[64px] p-[5%] flex-wrap my-[100px]" style={{overflow:'hidden'}}>
                <div className="flex-1 flex flex-col items-start-center justify-center gap-[16px] min-w-[200px]">
                    <Advantage2Svg width='100%' style={{ maxWidth: 510 }} />
                </div>
                <div className="flex-1 flex flex-col items-start justify-center gap-[16px] min-w-[200px]">
                    <div className="">
                        <Tag2 />
                    </div>
                    <div className="text-[#425596] font-[700] text-[24px] mt-[-10px]">
                        為學生自主學習提供資源
                    </div>
                    <div className="text-[black] font-[500] text-[20px] mt-[24px]">
                    平台可讓學生按各自的步伐學習及展示學習成效，<br/><br/>
                    亦可讓學生深化學習，加強對學習的投入感。
                    </div>
                </div>
            </div>

            {/*tag 3*/}
            <div className="flex flex-col items-center justify-center w-full bg-[#43D8BE40]">
                <div className="w-full max-w-[1400px] flex flex-row-col items-stretch justify-start gap-[64px] p-[5%] flex-wrap my-[100px]">
                    <div className="flex-1 flex flex-col items-start justify-center self-start gap-[16px] min-w-[200px]">
                        <div className="">
                            <Tag3 />
                        </div>
                        <div className="text-[#425596] font-[700] text-[24px] mt-[-10px]">
                        為教師教學與專業發展提供資源
                        </div>
                        <div className="text-[black] font-[500] text-[20px] mt-[24px]">
                        教師將獲邀參與相關專業培訓活動，<br/><br/>
                        了解線上閱讀的能力指標，<br/><br/>
                        提升對中文線上閱讀教學能力和評估素養。
                        </div>
                    </div>
                    <div className="flex-1 flex flex-col items-start-center justify-center gap-[16px] min-w-[200px]">
                        <Advantage3Svg width='100%' style={{ maxWidth: 510 }} />
                    </div>
                </div>
            </div>

            {/*tag 4*/}
            <div className="w-full max-w-[1400px] flex flex-row-m-reverse items-stretch justify-start gap-[64px] p-[5%] flex-wrap my-[100px]" style={{overflow:'hidden'}}>
                <div className="flex-1 flex flex-col items-start-center justify-center gap-[16px] min-w-[200px]">
                    <Advantage4Svg width='100%' style={{ maxWidth: 510 }} />
                </div>
                <div className="flex-1 flex flex-col items-start justify-center gap-[16px] min-w-[200px]">

                    <div className="">
                        <Tag4 />
                    </div>
                    <div className="text-[#425596] font-[700] text-[24px] mt-[-10px]">
                        即時回饋，進行針對性教學
                    </div>
                    <div className="text-[black] font-[500] text-[20px] mt-[24px]">
                        學生可獲得即時回饋，包括答案、<br/><br/>
                        解題分析等。教師可獲取學生的表現報告，<br/><br/>
                        從而可進行有針對性的教學。
                    </div>
                </div>
            </div>

            {/*tag 5*/}
            <div className="relative flex flex-col items-center justify-center w-full bg-[#43D8BE40]">
                <div className="w-full max-w-[1400px] flex flex-row-col items-stretch justify-start gap-[64px] p-[5%] flex-wrap my-[100px]">
                    <div className="flex-1 flex flex-col items-start justify-center self-start gap-[16px] min-w-[200px]">
                        <div className="">
                            <Tag5 />
                        </div>
                        <div className="text-[#425596] font-[700] text-[24px] mt-[-10px]">
                        了解學校的整體表現
                        </div>
                        <div className="text-[black] font-[500] text-[20px] mt-[24px]">
                            學校將得到學生調查問卷的完整報告以及<br/><br/>
                            與所有參與學校的橫向比較報告，<br/><br/>
                            既可更了解本校學生的線上閱讀能力水平，<br/><br/>
                            以及學校的整體表現。<br/><br/>
                        </div>
                    </div>
                    <div className="flex-1 flex flex-col items-start-center justify-center gap-[16px] min-w-[200px]">
                        <Advantage5Svg width='100%' style={{ maxWidth: 510 }} />
                    </div>
                </div>
                <div className="w-[50%] absolute right-[0] top-[-50%] z-[1]">
                    <BgSvg2 width='100%' />
                </div>
            </div>


            <Footer />



        </div>
    )
}